import "./marketing.css"
import React from "react"
import { createRoot } from "react-dom/client"
import App from "../marketing/App.jsx"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("marketing-root")
  if (container) {
    const priceCents = Number(container.dataset.priceCents) || 0
    const root = createRoot(container)
    root.render(<App priceCents={priceCents} />)
  }
})
